import React, { useState } from "react";
import { Button, Grid, IconButton } from "@mui/material";
import { gridSpacing } from "store/constant";
import MainCard from "ui-component/cards/MainCard";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Add from "./Add";
import List from "./List";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import VideosForMentoring from "../videos-for-mentoring/VideosForMentoring";

export default function VideoMaster() {
  const [isDisplay, setIsDisplay] = useState("Videos");
  const handleChange = () => {
    setIsDisplay("Videos");
  };
  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
        <MainCard
          content={false}
          title={
            isDisplay === "Videos"
              ? "Videos"
              : isDisplay === "Add"
                ? "Add"
                : "List"
          }
          secondary={
            isDisplay === "Videos" || isDisplay === "List" ? (
              <>
                <Button
                  variant="contained"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => setIsDisplay("Add")}
                >
                  Add
                </Button>
                {isDisplay === "Videos" ? (
                  <Button
                    sx={{ ml: 1 }}
                    variant="contained"
                    color="secondary"
                    onClick={() => setIsDisplay("List")}
                  >
                    List
                  </Button>
                ) : (
                  <Button
                    sx={{ ml: 1 }}
                    variant="contained"
                    startIcon={<PlayCircleIcon />}
                    color="secondary"
                    onClick={() => setIsDisplay("Videos")}
                  >
                    Videos
                  </Button>
                )}
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleChange}
                >
                  Back
                </Button>
                <Button
                  sx={{ ml: 1 }}
                  variant="contained"
                  color="secondary"
                  onClick={() => setIsDisplay("List")}
                >
                  List
                </Button>
              </>
            )
          }
        >
          {isDisplay === "Add" ? (
            <Add setIsDisplay={setIsDisplay} />
          ) : isDisplay === "Videos" ? (
            <VideosForMentoring />
          ) : (
            <List />
          )}
        </MainCard>
      </Grid>
    </Grid>
  );
}
